import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "my-orders-list-mobile__content" }

import { type PropType } from 'vue';

import type { Column as XTableColumn } from '@exchange/libs/components/x-components/src/lib/XTableColumn';

import InfoMessageBlock from './InfoMessageBlock.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyOrdersListMobile',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  marketId: { type: String, required: false },
  mobileHeader: { type: Array as PropType<Array<XTableColumn>>, required: true },
  showAllMarkets: { type: Boolean, required: true },
  showInfo: { type: Boolean, required: true },
  isFilledList: { type: Boolean, required: true },
  showOrderType: { type: Boolean, required: true },
  isFutures: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_ot_table = _resolveComponent("ot-table")!

  return (_openBlock(), _createBlock(_component_ot_table, {
    class: "my-orders-list-mobile",
    "header-class": 'my-orders-list-mobile__table-header',
    header: __props.mobileHeader
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "list", _normalizeProps(_guardReactiveProps({ itemClass: 'my-orders-list-mobile__item' }))),
        (__props.showInfo)
          ? (_openBlock(), _createBlock(InfoMessageBlock, {
              key: 0,
              class: "my-orders-list-mobile__message",
              "market-id": __props.marketId,
              "show-all-markets": __props.showAllMarkets,
              "authenticated-user": __props.authenticatedUser,
              "is-filled-list": __props.isFilledList,
              "is-positions": __props.isFutures
            }, null, 8, ["market-id", "show-all-markets", "authenticated-user", "is-filled-list", "is-positions"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["header"]))
}
}

})